/**
 * Monta configuração do painel "Encaminhar chamado" (modal V2).
 * Áreas/técnicos: hierarquia completa da equipe (não depende de coluna visível nem de OS na coluna).
 */

/**
 * Remove o técnico atual da lista (reencaminhamento entre técnicos).
 */
export function filterAreasExcludingTechnician(areasWithTechnicians, technicianName) {
  const normalizedCurrent = String(technicianName || '').trim().toLowerCase();
  return (areasWithTechnicians || [])
    .map((area) => {
      const technicians = (area.technicians || []).filter((name) => {
        if (!name) return false;
        const n = String(name).trim();
        if (!n) return false;
        if (normalizedCurrent && n.toLowerCase() === normalizedCurrent) return false;
        return true;
      });
      if (!technicians.length) return null;
      return {
        id: area.id,
        name: area.name || `Área ${area.id}`,
        technicians,
      };
    })
    .filter(Boolean);
}

export function buildEncaminharPanelConfig(orderRef, areasWithTechnicians, resolveOrderFromBoard) {
  const id = String(orderRef?.id ?? orderRef?.TB02115_CODIGO ?? '').trim();
  if (!id) return null;

  const found = typeof resolveOrderFromBoard === 'function' ? resolveOrderFromBoard(id) : null;
  const fg = String(orderRef?.forecastGroup || found?.forecastGroup || '').trim();
  const isEmAberto = fg.toLowerCase() === 'em aberto';
  const boardTech = orderRef?.detailModalBoardTechnician || found?.boardTechnician || '';
  if (!isEmAberto && !boardTech) return null;

  const source = isEmAberto ? 'open' : 'technician';
  const areas =
    source === 'technician'
      ? filterAreasExcludingTechnician(areasWithTechnicians, boardTech)
      : (areasWithTechnicians || [])
          .map((area) => {
            const technicians = (area.technicians || [])
              .map((name) => String(name || '').trim())
              .filter(Boolean);
            if (!technicians.length) return null;
            return {
              id: area.id,
              name: area.name || `Área ${area.id}`,
              technicians,
            };
          })
          .filter(Boolean);

  if (!areas.length) return null;

  return {
    orderId: id,
    orderIds: [id],
    fromTechnician: source === 'open' ? '' : boardTech,
    fromGroup: fg || (source === 'open' ? 'Em Aberto' : undefined),
    source,
    areas,
  };
}

export const ENCAMINHAR_SESSOES = [
  { id: 'previsto-hoje', label: 'Previsto para hoje', groupName: 'Previsto para hoje' },
  { id: 'previstas-amanha', label: 'Previstas para amanhã', groupName: 'Previstas para amanhã' },
  { id: 'futura', label: 'Futura', groupName: 'FUTURA' },
];
